/* PDFCommunity - (v147) theme, the only script that blocks the page.
   Loaded first in <head>, before style.css: it sets data-theme on <html>
   (automatic / light / dark), so a chosen theme never flashes the other one
   first. Everything else of pc-extras.js loads with defer (the theme button
   there uses these same functions). The choice is kept only in this browser
   (localStorage) and is never sent anywhere. No choice, or storage that is
   blocked, means automatic (the device setting, via the CSS media query). */
var PC_THEME_KEY = 'pc-theme', PC_THEMES = ['auto', 'light', 'dark'];
// the stored choice ('auto' when there is none), or null when storage is blocked
function pcStoredTheme() {
  var v;
  try { v = localStorage.getItem(PC_THEME_KEY); } catch (e) { return null; }
  return PC_THEMES.indexOf(v) > 0 ? v : 'auto';
}
function pcApplyTheme(t) {
  if (t === 'auto') document.documentElement.removeAttribute('data-theme');
  else document.documentElement.setAttribute('data-theme', t);
}
pcApplyTheme(pcStoredTheme() || 'auto'); // blocked storage: automatic
